import { Container, Typography, Box, Grid, TextField, InputLabel, IconButton, Button, MenuItem, Select, Backdrop, CircularProgress, Switch, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useForm, Controller } from 'react-hook-form'
import { useUtiles } from '../../../../shared/context/utilesContext'
import SelectLocationComponent from '../../components/SelectLocationComponent'
import { useInsumo } from '../../../../shared/context/insumoContext'
import SelectClassificationComponent from '../../components/SelectClassificationComponent'
import { ArrowBack as ArrowBackIcon, Save as SaveIcon } from '@mui/icons-material'
import { useNavigate, useParams } from 'react-router'
import SelectTypeInsumoComponent from '../../components/SelectTypeInsumoComponent'
import { useEffect } from 'react'
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material'
import AumentarDisminuirStockComponent from '../components/AumentarDisminuirStockComponent'
import { useAbility } from '../../../../shared/context/AbilityContext'
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import HistorialInsumoTaskComponent from '../components/HistorialInsumoTaskComponent'


export default function CreateUpdateInsumoView() {
    const { hash } = useParams()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const { toogleOpenSilder, locationString } = useUtiles()
    const { setSelectLocationParent, setSelectClassification1,
        setSelectClassification2, insumo, setInsumo,
        createInsumo, updateInsumo, loadingCreateInsumo,
        loadingUpdateInsumo, getInsumoByHash, loadingGetInsumoByHash, setTypeStock } = useInsumo()
    const navigate = useNavigate()
    const { handleSubmit, control, formState: { errors }, setValue } = useForm({
        defaultValues: {
            name: '',
            amount: 0,
            unit: '',
            type_insumo: '',
            date_entry: '',
            description: '',
            location: '',
            code: '',
            is_active: true
        }
    })

    const handleChangeField = (field, value) => {
        setValue(field, value)
        setInsumo({ ...insumo, [field]: value })
    }

    const handleCreateInsumo = () => {
        if (insumo.id) {
            updateInsumo()
        } else {
            createInsumo()
        }
    }

    const ability = useAbility();
    useEffect(() => {
        if (!ability.can('create', 'RESOURCES') && !ability.can('update', 'RESOURCES')) {
            navigate('/')
        }
    }, [ability])

    useEffect(() => {
        if (hash) {
            getInsumoByHash(hash)
        }
    }, [hash])

    useEffect(() => {
        if (insumo.id) {
            setValue('name', insumo.name)
            setValue('amount', insumo.amount)
            setValue('unit', insumo.unit)
            setValue('type_insumo', insumo.type_insumo)
            setValue('classification1', insumo.classification1)
            setValue('classification2', insumo.classification2)
            setValue('location', insumo.location)
            setValue('code', insumo.code)
            setValue('description', insumo.description)
            setValue('date_entry', insumo.date_entry)
        }
    }, [insumo])


    const handleIncreaseStock = () => {
        setTypeStock('entrada')
        toogleOpenSilder(<AumentarDisminuirStockComponent />, 500, 'Aumentar Stock')
    }

    const handleDecreaseStock = () => {
        setTypeStock('salida')
        toogleOpenSilder(<AumentarDisminuirStockComponent />, 500, 'Disminuir Stock')
    }

    const handleOpenHistorialInsumoTask = () => {
        toogleOpenSilder(<HistorialInsumoTaskComponent />, 500, 'Historial de uso del insumo')
    }

    return (
        <Container maxWidth="xl" sx={{
            padding: '0px', margin: '0px',
        }}>
            <form onSubmit={handleSubmit(handleCreateInsumo)}>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px'
                }}>
                    <IconButton
                        onClick={() => navigate('/insumos')}
                        sx={{
                            borderRadius: '12px',
                            padding: '8px',
                            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                            transition: 'all 0.2s',
                            "&:hover": {
                                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                                transform: 'translateY(-2px)'
                            }
                        }}
                    >
                        <ArrowBackIcon />
                    </IconButton>



                    <Box sx={{ display: 'flex', gap: 1, alignContent: 'center' }}>
                        <Box>
                            {insumo.id && <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginTop: isMobile ? '10px' : '0px' }}>
                                {!isMobile ? <Button startIcon={<AddIcon />} variant="contained" color="primary" onClick={() => handleIncreaseStock()}>
                                    Aume. Stock
                                </Button> : <IconButton variant='contained' sx={{ backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText }} onClick={() => handleIncreaseStock()}>
                                    <AddIcon />
                                </IconButton>}
                                {!isMobile ? <Button startIcon={<RemoveIcon />} variant="contained" color="primary" onClick={() => handleDecreaseStock()}>
                                    Dism. Stock
                                </Button> : <IconButton variant='contained' sx={{ backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText }} onClick={() => handleDecreaseStock()}>
                                    <RemoveIcon />
                                </IconButton>}
                            </Box>}
                        </Box>
                        <Button
                            variant="contained"
                            startIcon={<ManageSearchIcon />}
                            onClick={() => handleOpenHistorialInsumoTask()}
                            sx={{
                                borderRadius: '8px',
                                padding: '8px 25px',
                                backgroundColor: theme.palette.primary.main,
                                color: theme.palette.primary.contrastText,
                                borderRadius: '50px',
                                transition: 'all 0.2s',

                                "&:hover": {
                                    backgroundColor: theme.palette.primary.dark,
                                    transform: 'translateY(-2px)'
                                }
                            }}>
                            Historial
                        </Button>

                        <Button
                            variant="contained"
                            startIcon={<SaveIcon />}
                            type='submit'
                            sx={{
                                borderRadius: '8px',
                                padding: '8px 25px',
                                backgroundColor: theme.palette.primary.main,
                                color: theme.palette.primary.contrastText,
                                borderRadius: '50px',
                                transition: 'all 0.2s',

                                "&:hover": {
                                    backgroundColor: theme.palette.primary.dark,
                                    transform: 'translateY(-2px)'
                                }
                            }}
                        >
                            Guardar
                        </Button>
                    </Box>



                </Box>


                <Box sx={{
                    borderRadius: '10px',
                    backgroundColor: theme.palette.background.paper,
                    padding: '20px',
                    position: 'relative'
                }}>
                    <Typography variant="h6" sx={{
                        fontWeight: 'bold',
                        marginBottom: '10px',
                        fontSize: '20px',
                    }}>
                        {hash ? 'Editar Insumo' : 'Crear Insumo'}
                    </Typography>

                    <Grid container spacing={2} columns={12}>

                        <Grid item size={{ xs: 12 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Selecciona la Ubicación</InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Seleccione la ubicación de almacenamiento para este insumo
                            </Typography>
                            <Controller
                                control={control}
                                name="location"
                                render={({ field }) => (
                                    <TextField
                                        placeholder='Buscar ubicación'
                                        fullWidth
                                        value={locationString(insumo.location)}
                                        onChange={(e) => handleChangeField(field.name, e.target.value)}
                                        error={!!errors.name}
                                        helperText={errors.name?.message}
                                        onClick={() => toogleOpenSilder(<SelectLocationComponent setSelectLocationParent={setSelectLocationParent} />, 500, 'Buscar ubicación')}
                                        slotProps={{
                                            input: {
                                                readOnly: true
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item size={{ xs: 12, md: 6 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Nombre <span style={{ color: 'red' }}>*</span></InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Ingrese el nombre del insumo
                            </Typography>
                            <Controller
                                control={control}
                                name="name"
                                rules={{
                                    required: 'El nombre es requerido'
                                }}
                                render={({ field }) => (
                                    <TextField
                                        placeholder='Nombre'
                                        fullWidth
                                        value={field.value}
                                        onChange={(e) => handleChangeField(field.name, e.target.value)}
                                        error={!!errors.name}
                                        helperText={errors.name?.message}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item size={{ xs: 12, md: 6 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Cantidad</InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Ingrese la cantidad del insumo
                            </Typography>
                            <Controller
                                control={control}
                                name="amount"

                                render={({ field }) => (
                                    <TextField
                                        placeholder='Cantidad'
                                        fullWidth
                                        value={field.value}
                                        onChange={(e) => handleChangeField(field.name, e.target.value)}
                                        error={!!errors.amount}
                                        helperText={errors.amount?.message}
                                        type='number'
                                        disabled={insumo.id}
                                    />
                                )}
                            />


                        </Grid>

                        <Grid item size={{ xs: 12, md: 6 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Unidad de Medida</InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Ingrese la unidad del insumo
                            </Typography>
                            <Controller
                                control={control}
                                name="unit"
                                render={({ field }) => (
                                    <Select
                                        placeholder='Unidad de Medida'
                                        fullWidth
                                        value={field.value}
                                        onChange={(e) => handleChangeField(field.name, e.target.value)}
                                        error={!!errors.unit}
                                        helperText={errors.unit?.message}
                                    >
                                        <MenuItem value="unidad">Unidad (UN)</MenuItem>
                                        <MenuItem value="litro">Litro (Lt)</MenuItem>
                                        <MenuItem value="kilogramo">Kilogramo (Kg)</MenuItem>
                                        <MenuItem value="gramo">Gramo (G)</MenuItem>
                                        <MenuItem value="galón">Galón (M3)</MenuItem>
                                        <MenuItem value="par">Par</MenuItem>
                                        <MenuItem value="kit">Kit</MenuItem>
                                        <MenuItem value="metro">Metro (M)</MenuItem>
                                        <MenuItem value="centimetro">Centímetro (Cm)</MenuItem>
                                        <MenuItem value="rollo">Rollo</MenuItem>
                                        <MenuItem value="bolsa">Bolsa</MenuItem>
                                        <MenuItem value="caja">Caja</MenuItem>
                                        <MenuItem value="tubo">Tubo</MenuItem>
                                        <MenuItem value="otro">Otro</MenuItem>

                                    </Select>
                                )}
                            />
                        </Grid>

                        <Grid item size={{ xs: 12, md: 6 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Fecha de Entrada</InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Ingrese la fecha de entrada del insumo
                            </Typography>
                            <Controller
                                control={control}
                                name="date_entry"
                                render={({ field }) => (
                                    <TextField
                                        type='date'
                                        placeholder='Fecha de Entrada'
                                        fullWidth
                                        value={field.value}
                                        onChange={(e) => handleChangeField(field.name, e.target.value)}
                                        error={!!errors.date_entry}
                                        helperText={errors.date_entry?.message}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item size={{ xs: 12, md: 6 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Código</InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Ingrese el código del insumo
                            </Typography>
                            <Controller
                                control={control}
                                name="code"
                                render={({ field }) => (
                                    <TextField
                                        placeholder='Código'
                                        fullWidth
                                        value={field.value}
                                        onChange={(e) => handleChangeField(field.name, e.target.value)}
                                        error={!!errors.code}
                                        helperText={errors.code?.message}
                                    />
                                )}
                            />

                        </Grid>

                        <Grid item size={{ xs: 12, md: 6 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Tipo de Insumo</InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Seleccione el tipo de insumo
                            </Typography>
                            <Controller
                                control={control}
                                name="type_insumo"
                                render={({ field }) => (
                                    <TextField
                                        placeholder='Tipo de Insumo'
                                        fullWidth
                                        value={insumo.type_insumo?.name}
                                        onChange={(e) => handleChangeField(field.name, e.target.value)}
                                        error={!!errors.type_insumo}
                                        helperText={errors.type_insumo?.message}
                                        onClick={() => toogleOpenSilder(<SelectTypeInsumoComponent />, 500, 'Buscar tipo de insumo')}
                                        slotProps={{
                                            input: {
                                                readOnly: true
                                            }
                                        }}
                                    />
                                )}
                            />

                        </Grid>

                        <Grid item size={{ xs: 12, md: 6 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Clasificación 1</InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Ingrese la clasificación 1 del insumo
                            </Typography>
                            <Controller
                                control={control}
                                name="classification1"
                                render={({ field }) => (
                                    <TextField
                                        placeholder='Clasificación 1'
                                        fullWidth
                                        value={insumo.classification1?.value}
                                        onChange={(e) => handleChangeField(field.name, e.target.value)}
                                        error={!!errors.classification1}
                                        helperText={errors.classification1?.message}
                                        slotProps={{
                                            input: {
                                                readOnly: true
                                            }
                                        }}
                                        onClick={() => toogleOpenSilder(<SelectClassificationComponent setSelectClassification={setSelectClassification1} type_asset='insumos' number={1} />, 500, 'Buscar clasificación 1')}
                                    />
                                )}
                            />


                        </Grid>

                        <Grid item size={{ xs: 12, md: 6 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Clasificación 2</InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Ingrese la clasificación 2 del insumo
                            </Typography>
                            <Controller
                                control={control}
                                name="classification2"
                                render={({ field }) => (
                                    <TextField
                                        placeholder='Clasificación 2'
                                        fullWidth
                                        value={insumo.classification2?.value}
                                        onChange={(e) => handleChangeField(field.name, e.target.value)}
                                        error={!!errors.classification2}
                                        helperText={errors.classification2?.message}
                                        slotProps={{
                                            input: {
                                                readOnly: true
                                            }
                                        }}
                                        onClick={() => toogleOpenSilder(<SelectClassificationComponent setSelectClassification={setSelectClassification2} type_asset='insumos' number={2} />, 500, 'Buscar clasificación 2')}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item size={{ xs: 12 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Descripción</InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Ingrese la descripción del insumo
                            </Typography>
                            <Controller
                                control={control}
                                name="description"
                                render={({ field }) => (
                                    <TextField
                                        multiline
                                        rows={4}
                                        placeholder='Descripción'
                                        fullWidth
                                        value={field.value}
                                        onChange={(e) => handleChangeField(field.name, e.target.value)}
                                        error={!!errors.description}
                                        helperText={errors.description?.message}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item size={{ xs: 12 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Habilitado</InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Seleccione si el insumo está habilitado
                            </Typography>
                            <Controller
                                control={control}
                                name="is_active"
                                render={({ field }) => (
                                    <Switch
                                        checked={insumo.is_active}
                                        onChange={(e) => handleChangeField(field.name, e.target.checked)}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </form>
            <Backdrop open={loadingCreateInsumo} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                    <CircularProgress />
                    <Typography variant="h6" sx={{ color: theme.palette.text.primary }}>
                        Creando insumo...
                    </Typography>
                </Box>
            </Backdrop>

            <Backdrop open={loadingGetInsumoByHash} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                    <CircularProgress />
                    <Typography variant="h6" sx={{ color: theme.palette.text.primary }}>
                        Cargando insumo...
                    </Typography>
                </Box>
            </Backdrop>
        </Container>
    )
}